<!-- 首页 -->
<template>
  <div ref="home" class="home">
    <!-- 导航组件 -->
    <Header></Header>
    <!-- 侧边栏组件 -->
    <Sidebar></Sidebar>
    <!-- 組件部分 -->
    <router-view v-if="navList.length > 0 "></router-view>
    <LoadingBanner v-loading="loading" v-else></LoadingBanner>
    <!-- 底部組件 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/comForPc/header.vue'
import Sidebar from '@/components/comForPc/sidebar.vue'
import Footer from '@/components/comForPc/footer.vue'
import LoadingBanner from '@/components/comForPc/loading_banner.vue'
export default {
  components: { Header, Sidebar, Footer, LoadingBanner },
  data () {
    return {
      navList: [],
      loading: true
    }
  },
  methods: {
    getNavList () {
      this.$axios.get('/blog/api/getcategorys')
        .then(res => {
          localStorage.setItem('navList', JSON.stringify(res.data))
          this.navList = res.data
          this.loading = false
        }).catch(err => {
          console.log(err)
        })
    }
  },
  created () {
    this.getNavList()
  },
  mounted () {
  },
  destroyed () {
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/index.vue